export const normalizeTurkishPhone = (phone) => {
  if (!phone) return "";
  let digits = String(phone).replace(/\D/g, "");
  if (digits.startsWith("90") && digits.length >= 12) digits = digits.slice(2);
  if (digits.startsWith("0")) digits = digits.slice(1);
  return digits;
};

export const phonesMatch = (a, b) => {
  if (!a || !b) return false;
  return normalizeTurkishPhone(a) === normalizeTurkishPhone(b);
};

export const getAgentPhonesForRecord = (agentId, agents) => {
  const agent = agents.find((a) => String(a.id) === String(agentId));
  if (!agent?.gsm) return [];
  return agent.gsm.split(",").map((s) => normalizeTurkishPhone(s.trim())).filter(Boolean);
};

export const getCustomerPhoneFromRecord = (record, agents) => {
  if (!record) return null;
  const agentPhones = getAgentPhonesForRecord(record.agentId, agents);
  const arayanNorm = normalizeTurkishPhone(record.arayan_numara);
  const arananNorm = normalizeTurkishPhone(record.aranan_numara);
  const arayanIsAgent = agentPhones.some((p) => p === arayanNorm);
  const arananIsAgent = agentPhones.some((p) => p === arananNorm);

  if (arayanIsAgent && !arananIsAgent) return record.aranan_numara;
  if (arananIsAgent && !arayanIsAgent) return record.arayan_numara;
  if (String(record.yon) === "1") return record.arayan_numara;
  if (String(record.yon) === "2") return record.aranan_numara;
  return arayanIsAgent ? record.aranan_numara : record.arayan_numara;
};

export const isCustomerPhone = (record, phone, agents) => {
  const customerPhone = getCustomerPhoneFromRecord(record, agents);
  return phonesMatch(phone, customerPhone);
};

export const getAgentNameForRecord = (record, agents) => {
  if (record?.agent_name) return record.agent_name;
  const agent = agents.find((a) => String(a.id) === String(record?.agentId));
  return agent?.ad_soyad || null;
};
